<template>
    <div class="cart-page__right col-3 col-md-12 hidden-md">

        <div class="cart-block cart-block--total cart-block--total-2">
            <div class="cart-block__title">ИТОГО</div>

            <div class="cart-block__item" v-for="basketItem in basketItems" :key="basketItem.id">
                <div class="cart-block__img">
                    <img
                            :src="basketItem.photo.x1.SRC"
                            :srcset="basketItem.photo.x1.SRC + ' 1x, ' + basketItem.photo.x2.SRC + ' 2x'"></div>
                <div class="cart-block__item__info">
                    <p class="cart-block__item__name">{{ basketItem.name }}</p>
                    <div class="cart-block__item__price" v-html="basketItem.priceFormatted"></div>
                </div>
            </div>


            <div class="cart-block__row cart-block__row--delivery">
                <p>Доставка</p>
                <p>{{ deliveryPrice }}</p>
            </div>
            <div class="cart-block__row cart-block__row--delivery-desc">
                <p>Доставка до склада в Москве включена в стоимость</p>
            </div>

            <div class="cart-block__row cart-block__row--total">
                <p>Всего</p>
                <p v-html="orderTotalPrice"></p>
            </div>
            <div class="cart-block__buttons">
                <a v-if="currentStep === 'final'" @click.prevent="saveOrder(model)" href="#" class="btn btn--black btn--block btn--next btn--md">
                    <span>Оформить заказ</span>
                    <svg class="icon btn__icon">
                        <use xlink:href="/local/templates/reloft2020/asset/images/sprite.svg#btn-arrow"></use>
                    </svg>
                </a>
                <a v-else @click.prevent="nextStep" href="#" class="btn btn--black btn--block btn--next btn--md">
                    <span>Далее</span>
                    <svg class="icon btn__icon">
                        <use xlink:href="/local/templates/reloft2020/asset/images/sprite.svg#btn-arrow"></use>
                    </svg>
                </a>
                <div class="input-row__error" v-for="(error, fieldName) in errors" :key="fieldName">{{ error }}</div>
            </div>
        </div>

        <div class="cart-page__police">При нажатии кнопки Далее Вы соглашаетесь с нашей Пользовательской офертой и правилами конфиденциальности и порядком использования cookie</div>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';

    export default {
        name: 'OrderSummary',
        computed: {
            ...mapState('StoreCheckout', [
                'orderSummary',
                'model',
                'errors',
                'currentStep',
                'orderSaveResult',
                'availableDeliveries'
            ]),
            basketItems: function () {
                return this.orderSummary.basket ? this.orderSummary.basket.items : [];
            },
            orderTotalPrice: function () {
                return this.orderSummary.totalPrice ? this.orderSummary.totalPrice.formatted : '';
            },
            availableDeliveries: function () {
                return this.orderSummary.availableDeliveries ?? [];
            },
            deliveryPrice: function () {
                if (this.model.deliveryId.length) {
                    let delivery = this.availableDeliveries.find(delivery => parseInt(delivery.ID) === parseInt(this.model.deliveryId));
                    return delivery.PRICE_FORMATTED;
                }

                return '-';
            },
        },
        methods: {
            ...mapActions('StoreCheckout', ['loadOrderSummary', 'nextStep', 'saveOrder']),
        },
        watch: {
            'orderSaveResult.orderId': function (val) {
                if (val) {
                    window.location.href = '/checkout?ORDER_ID=' + this.orderSaveResult.orderId;
                }
            }
        },
        beforeMount() {
            this.loadOrderSummary(this.model);
        }
    }
</script>